import { useIntersection } from '@mantine/hooks'
import { useSetAtom } from 'jotai'
import { atomWithImmer } from 'jotai-immer'
import { useEffect } from 'react'

export { stateAtom as simpleGenFormStateAtom }
const stateAtom = atomWithImmer({
  scrolledOut: false,
})

export function useObserveSimpleGenIntersection() {
  const updateState = useSetAtom(stateAtom)
  const { ref: elRef, entry: intersection } = useIntersection({
    threshold: 1,
  })

  useEffect(() => {
    if (intersection) {
      updateState(state => {
        state.scrolledOut = !intersection.isIntersecting
      })
    }

    return () => {
      updateState(state => {
        state.scrolledOut = false
      })
    }
  }, [intersection, updateState])

  return elRef
}
